<!--
	its frontend

	Page, submodule from App

    @file         Page_login.svelte
    @author       Robert Fischer, fischer@tForge.eu
    @date         05/2022
    @copyright    tForge
-->


<script>
    import { URL_API } 	from './minions';

    import { LogInIcon }       from 'svelte-feather-icons';

    import {createEventDispatcher} from "svelte";
    let dispatch =  createEventDispatcher();



// ============================ store variables ==============================

    import { st_login } from './stores';

    let login;
    st_login.subscribe(value => {
		login = value;
	});



// =============================== Test Backend ==============================

    let login_user, login_pwd;


    const loginRequest = async ()=> {

        const reply = await fetch(URL_API("login"), {
            method:'post',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                user: login_user,
                pwd: login_pwd}) })
            .catch((err)=> {
                dispatch('message', {text: "Sorry, could not reach server."});
            });

        if (reply.ok){
            const data = await reply.json();
            st_login.set({user:login_user, pwd:login_pwd, 
                            level:data.level, key:""})
        }
        else {
            dispatch('message', {text: "Computer says no."});
        }

    };//loginRequest()



// ========================== Construction / Init ============================

    import { onMount, onDestroy } 	from 'svelte';


    onMount(async () => {

    });//onMount()


    function close(nextPage="") {
        dispatch('close', {page: nextPage});
    }//close()


	onDestroy(async () => {

	});//onDestroy()

</script>




<!-- =============================  H T M L  ============================= -->



<div class="page">

    <div class="box-center">
        <h1>Login</h1>

        <div>
            
            <div class="box-input">
                <label for="txt-user">User</label>
                <input id="txt-user" bind:value={login_user} autocomplete="off"
                        type="text" class="input" placeholder="Username">
            </div>

            <div class="box-input">
                <label for="txt-pwd">Password</label>
                <input id="txt-pwd" bind:value={login_pwd}
                        type="password" class="input" placeholder="Password">
            </div>

            <button class="btn"
                on:click={loginRequest}>
                <LogInIcon size="1x" /> Login
            </button>

        </div>


    </div>


</div>



<!-- ============================  S T Y L E  ============================ -->



<style>
    .page{
        height: 90vh;
        display: flex;
		align-items: center;
		justify-content: center;
    }

    h1 {
        margin-bottom: 1em;
    }

    .box-center{
        text-align: left;        
        margin: auto;
    }

    .box-input {
        margin-top: 1.5em;
        margin-right: 0px;
        width: 300px;
    }

    .btn {
        margin-top: 1.5em;
        width: 100%
    }

</style>